<div class="forgot-shell">

  <div class="forgot-card">

    <div class="frame-parent">
      <img class="frame-child" src="assets/images/CRC_logo.svg" alt="ResourceCenter logo" />
      <div class="icon-parent">
        <div class="help-icon" (click)="clickShowHelp()">
          <img class="iconshelp-circle" src="assets/images/help-circle.svg" alt="">
        </div>
        <div class="iconshelp-button"></div>
      </div>
    </div>


    <div class="forgot-main">

      <section class="forgot-left">
        <div class="forgot-content">
          <div class="forgot-header">
            <div class="forgot-icon-wrap" aria-hidden="true">
              <img class="forgot-icon" src="assets/images/user.svg" alt="" />
            </div>

            <div class="forgot-title">
              <span class="forgot-title-strong">{{"registration.label.registration" | translate }}</span>
            </div>

            @if(page===RegistrationConstants.REGISTRATION_PAGE_ONE) {
              <div class="reg-progress-bar-parent">
                <div class="reg-progress-bar-child"></div>
                <div class="reg-progress-bar-item"></div>
              </div>

              <div class="register-instructions-container">
                <span [innerHTML]="'userprofile.text.registration.instructions' | translate"> </span><br/>
                <a [href]="supportUrl"><span class="crcsupportcompsychcom">{{supportMail}}</span></a>
              </div>

            } @else if(page===RegistrationConstants.REGISTRATION_PAGE_TWO) {
              <div class="reg-progress-bar-parent">
                <div class="reg-progress-bar-child"></div>
                <div class="reg-progress-bar-child"></div>
              </div>
              <div class="register-instructions-container">
                <span [innerHTML]="'userprofile.text.registration.instructions2' | translate"> </span><br/>
              </div>

            }
          </div>

          <div class="forgot-form">

            @if (errors.length > 0) {
              <div class="notification-bar" role="alert" aria-live="assertive">
                <div class="login-error">
                  <img class="icons-alert-circle" src="assets/images/alert-circle.svg" alt="Error" />
                  <div class="message">
                    @for (error of errors; track $index) {
                      <li style="list-style: none" [innerHTML]="error"></li>
                    }
                  </div>
                </div>
              </div>
            }
            @if(page===RegistrationConstants.REGISTRATION_PAGE_ONE) {
              <form class="forgot-form" (ngSubmit)="submit()" [formGroup]="registrationForm">

                <app-standard-form-field
                  label="registration.label.registrationNumber"
                  controlName="registrationNumber" inputId="registrationNumber"
                  [parentForm]="registrationForm" [required]="true">
                </app-standard-form-field>

                <app-standard-form-field
                  label="registration.label.emailAddress"
                  controlName="registrationEmail" inputId="registrationEmail"
                  [parentForm]="registrationForm" [required]="true">
                </app-standard-form-field>

                <button class="forgot-submit" type="submit">
                  {{ "registration.label.next" | translate }}
                </button>
              </form>
            } @else if(page===RegistrationConstants.REGISTRATION_PAGE_TWO) {

              <form class="forgot-form" (ngSubmit)="submit()" [formGroup]="registrationForm">

                <div class="frame-div">
                  <div class="frame-parent2">
                    <div class="frame-parent3">
                      <div class="frame-parent4">
                        <div class="first-name-wrapper">
                          <div class="first-name">{{'userprofile.label.firstname'|translate}}</div>
                        </div>
                        <div class="keith-wrapper">
                          <div class="keith">{{registrationDtls.firstName}}</div>
                        </div>
                      </div>
                      <div class="frame-parent5">
                        <div class="last-name-wrapper">
                          <div class="first-name">{{'userprofile.label.lastname'|translate}}</div>
                        </div>
                        <div class="keith-container">
                          <div class="keith">{{registrationDtls.lastName}}</div>
                        </div>
                      </div>
                    </div>

                    <div class="frame-parent3">
                      <div class="frame-parent4">
                        <div class="first-name-wrapper">
                          <div class="first-name">{{'userprofile.label.accountName'|translate}}</div>
                        </div>
                        <div class="keith-wrapper">
                          <div class="keith">{{registrationDtls.accountName}}</div>
                        </div>
                      </div>
                      <div class="frame-parent5">
                        <div class="last-name-wrapper">
                          <div class="first-name">{{'registration.label.registrationNumber'|translate}}</div>
                        </div>
                        <div class="keith-container">
                          <div class="keith">{{registrationDtls.contactId}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <app-standard-form-field
                  label="userprofile.label.username"
                  controlName="username" inputId="username"
                  [parentForm]="registrationForm" [required]="true">
                </app-standard-form-field>

                <app-password-input [parentForm]="registrationForm" [inputId]="'password'"
                  [controlName]="'password'" [label]="'userprofile.label.password'" [required]="true">
                </app-password-input>


                <app-password-input [parentForm]="registrationForm" [inputId]="'confirmPassword'"
                  [controlName]="'confirmPassword'" [label]="'userprofile.label.confirmPassword'" [required]="true">
                </app-password-input>

                <button class="forgot-submit" type="submit">
                   {{ "registration.label.submit" | translate }}
                </button>

              </form>
            }
          </div>

          <div class="forgot-return">
            <a class="forgot-return-link" [routerLink]="UrlConstants.loginUrl">
              <span class="forgot-return-light">{{ 'registration.text.addendum.alreadyRegistered' | translate}}</span>
              <span class="forgot-return-strong">{{ 'registration.text.loginHere' | translate}}</span>
            </a>
          </div>

        </div>
      </section>

      <!-- RIGHT: Image panel -->
      <aside class="forgot-right" aria-hidden="true">
        <img class="forgot-image" src="assets/images/CRC-Login-Image.jpg" alt="" />
      </aside>
    </div>

  </div>
</div>


@if(showHelp){
  <app-registration-help
    [title]="'registration.help.title'"
    [subHeading]="'registration.help.subHeading'"
    [footer]="'registration.help.subFooter'"
    [supportMail]=supportMail
    [helpItems]="helpItems"
    (onClose)="closeHelp()">
  </app-registration-help>
}

